import {
  ComponentPropsWithRef,
  forwardRef,
  InputHTMLAttributes,
  memo,
  ReactNode,
  RefObject,
} from 'react';
import { Switch as ChakraSwitch, SwitchRootProps } from '@chakra-ui/react';

import { Nullable } from '../../../types';

export type SwitchProps = SwitchRootProps & {
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  rootRef?: RefObject<Nullable<HTMLLabelElement>>;
  trackLabel?: { on: ReactNode; off: ReactNode };
  thumbLabel?: { on: ReactNode; off: ReactNode };
};

const SwitchComponent = (
  props: SwitchProps,
  ref: ComponentPropsWithRef<'input'>['ref'],
) => {
  const { inputProps, children, rootRef, trackLabel, thumbLabel, ...rest } =
    props;

  return (
    <ChakraSwitch.Root ref={rootRef} {...rest}>
      <ChakraSwitch.HiddenInput ref={ref} {...inputProps} />
      <ChakraSwitch.Control>
        <ChakraSwitch.Thumb>
          {thumbLabel && (
            <ChakraSwitch.ThumbIndicator fallback={thumbLabel?.off}>
              {thumbLabel?.on}
            </ChakraSwitch.ThumbIndicator>
          )}
        </ChakraSwitch.Thumb>
        {trackLabel && (
          <ChakraSwitch.Indicator fallback={trackLabel.off}>
            {trackLabel.on}
          </ChakraSwitch.Indicator>
        )}
      </ChakraSwitch.Control>
      {children != null && <ChakraSwitch.Label>{children}</ChakraSwitch.Label>}
    </ChakraSwitch.Root>
  );
};

export const Switch = memo(
  forwardRef<HTMLInputElement, SwitchProps>(SwitchComponent),
);
